export const COUNTRY_CODES = [
  { code: "+58",  flag: "🇻🇪", name: "Venezuela", digits: 10, strip0: true  },
  { code: "+57",  flag: "🇨🇴", name: "Colombia",  digits: 10, strip0: false },
  { code: "+52",  flag: "🇲🇽", name: "México",    digits: 10, strip0: false },
  { code: "+54",  flag: "🇦🇷", name: "Argentina", digits: 10, strip0: false },
  { code: "+56",  flag: "🇨🇱", name: "Chile",     digits: 9,  strip0: false },
  { code: "+593", flag: "🇪🇨", name: "Ecuador",   digits: 9,  strip0: true  },
  { code: "+51",  flag: "🇵🇪", name: "Perú",      digits: 9,  strip0: false },
  { code: "+34",  flag: "🇪🇸", name: "España",    digits: 9,  strip0: false },
  { code: "+1",   flag: "🇺🇸", name: "EE.UU.",    digits: 10, strip0: false },
];

export const RYDER_COUNTRY_CODES = COUNTRY_CODES.filter((c) => c.code === "+58" || c.code === "+57");

export const getCleanPhone = (phone, countryCode) => {
  const country = COUNTRY_CODES.find((c) => c.code === countryCode);
  let clean = phone.replace(/\D/g, "");
  if (country?.strip0 && clean.startsWith("0")) clean = clean.slice(1);
  return { clean, expected: country?.digits ?? 10 };
};
